import { Container, Graphics } from '@pixi/react'
import { Draw, FixedContainerV2, ScrollBox, useChipSetStore, useGameRuleStore } from '@slot-nx/core'
import { Assets } from 'pixi.js'
import { useCallback } from 'react'
import fga from '../../../asset/images/gameRules/FGA.png'
import fgb from '../../../asset/images/gameRules/FGB.png'

import bayBar from '../../../asset/images/gameRules/BayBar.png'

import { Paragraph1 } from './Paragraph1'
import { gameConfig } from '../../config'
import { Paragraph0 } from './Paragraph0'
import { GrayBackground } from '../GrayBackground'
import { Paragraph2 } from './Paragraph2'
import { Paragraph3 } from './Paragraph3'
import { Paragraph4 } from './Paragraph4'
import { Paragraph5 } from './Paragraph5'
import { Paragraph6 } from './Paragraph6'
import { Paragraph7 } from './Paragraph7'
import { Paragraph8 } from './Paragraph8'
import { Paragraph9 } from './Paragraph9'
import { Paragraph10 } from './Paragraph10'
import { CloseButton } from '../menu/CloseButton'

Assets.addBundle('PayTable', {

  bayBar: { src: bayBar, loadParser: 'loadTextures' },
  fga: { src: fga, loadParser: 'loadTextures' },
  fgb: { src: fgb, loadParser: 'loadTextures' },
})

const width = gameConfig.resolution.width
const height = gameConfig.resolution.height
const indentSize = 10
const indentOffset = indentSize / 2
const closeButtonSize = 70
const closeButtonOffset = 20
const closeButtonX = width - closeButtonSize - indentOffset - closeButtonOffset
const topMaskSize = closeButtonSize + closeButtonOffset

export const PayTable = () => {
  const isOpened = useGameRuleStore(x => x.isOpened)

  const drawBox = useCallback<Draw>((graphics) => {
    graphics.clear()
    graphics.lineStyle(2, '#C1C1C1', 1)
    graphics.beginFill('black', 0.8)
    graphics.drawRoundedRect(indentOffset, indentOffset, width - indentSize, height - indentSize, 30)
    graphics.endFill()
  }, [])
  return (
    isOpened
      ? (
          <GrayBackground width={width} height={height}>
            <Container name="paytable">
              <Graphics
                draw={drawBox}
              />
              <CloseButton
                x={closeButtonX}
                y={closeButtonOffset}
                width={closeButtonSize}
                height={closeButtonSize}
                onPress={() => {
                  useGameRuleStore.setState({ isOpened: false })
                }}
              />
              <PayTableBody />
            </Container>
          </GrayBackground>
        )
      : null
  )
}

const PayTableBody = () => {
  const currentStake = useChipSetStore(x => x.computed.currentStake)
  return (
    <FixedContainerV2 name="Paytable Content" x={0} y={topMaskSize} width={width - indentSize} height={1750}>
      <ScrollBox width={width - indentSize} height={1750} y={0} x={0}>
        <Paragraph0 y={30} width={width} height={0} />
        <Paragraph1 y={260} width={width} height={0} stake={currentStake} />
        <Paragraph2 y={1800} width={width} height={0} />
        <Paragraph3 y={2600} width={width} height={0} />
        <Paragraph4 y={3100} width={width} height={0} />
        <Paragraph5 y={3750} width={width} height={0} />
        <Paragraph6 y={4250} width={width} height={0} />
        <Paragraph7 y={5500} width={width} height={0} />
        <Paragraph8 y={5900} width={width} height={0} />
        <Paragraph9 y={6300} width={width} height={0} />
        <Paragraph10 y={6700} width={width} height={0} />
      </ScrollBox>
    </FixedContainerV2>
  )
}
